<!--
  AI:
  Status: 'in progress'
  Type: Component Template
  SubType: Tree-Table
  Reason: Renders the custom "Objekt-Zuordnung" tree. Uses <p-treeTable> directly
          (no widget wrapper) because the plan mandates a bespoke tree-table. Row
          click routes back to the parent page via (nodeSelect) event.
-->

<div class="flex flex-column gap-2 h-full">

    <!-- Header row: title + reload button. Keeps the surface consistent with the
         right-panel card without pulling in a custom CSS file. -->
    <div class="flex align-items-center gap-2">
        <i class="fa-regular fa-sitemap text-color-secondary"></i>
        <span class="font-semibold">Objekt-Zuordnung</span>
        <span class="text-color-secondary text-sm"
              *ngIf="treeNodes.length > 0">{{ treeNodes.length }} Datensätze</span>
        <p-button icon="fa-regular fa-rotate"
                  severity="secondary"
                  [text]="true"
                  size="small"
                  class="ml-auto"
                  [loading]="loading"
                  [disabled]="loading || !importId"
                  (onClick)="reload()"></p-button>
    </div>

    <!-- Empty / loading / error states — keep them inline so the p-treeTable
         below is only rendered once we actually have data. -->
    @if (loading) {
        <div class="flex align-items-center gap-2 text-color-secondary">
            <i class="fa-regular fa-spinner fa-spin"></i>
            <span>Lade Objekt-Zuordnung...</span>
        </div>
    } @else if (errorMessage) {
        <div class="surface-100 border-round p-3 text-red-600 flex align-items-center gap-2">
            <i class="fa-regular fa-triangle-exclamation"></i>
            <span>{{ errorMessage }}</span>
        </div>
    } @else if (treeNodes.length === 0) {
        <div class="surface-100 border-round p-3 text-color-secondary flex align-items-center gap-2">
            <i class="fa-regular fa-circle-info"></i>
            <span>Keine Datensätze vorhanden</span>
        </div>
    } @else {
        <!-- The actual tree-table. Columns:
              1. Objekt (label + icon, expander in first column)
              2. Typ   (kind / sub-label)
              3. Status (tag)
              4. Konflikte (badge, only populated on record/structure rows) -->
        <p-treeTable [value]="treeNodes"
                     [scrollable]="true"
                     scrollHeight="flex"
                     dataKey="nodeKey"
                     styleClass="p-treetable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 45%">Objekt</th>
                    <th style="width: 25%">Typ</th>
                    <th style="width: 20%">Status</th>
                    <th style="width: 10%">Konflikte</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr [ttRow]="rowNode"
                    class="cursor-pointer"
                    (click)="onRowClick(rowData)">
                    <td>
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        <i [class]="rowData.icon" class="mr-2 text-color-secondary"></i>
                        <span>{{ rowData.label }}</span>
                    </td>
                    <td>
                        <span class="text-color-secondary">{{ rowData.subLabel }}</span>
                    </td>
                    <td>
                        @if (rowData.statusLabel) {
                            <p-tag [value]="rowData.statusLabel"
                                   [severity]="rowData.statusSeverity"></p-tag>
                        }
                    </td>
                    <td>
                        @if (rowData.conflictBadge) {
                            <p-tag [value]="rowData.conflictBadge"
                                   severity="warn"></p-tag>
                        }
                    </td>
                </tr>
            </ng-template>
        </p-treeTable>
    }
</div>
